<template>
  <modal
    class="color-picker-modal"
    content-class="color-picker-modal-content"
    :name="modalName"
    transition="pop-out"
    :height="450"
    :width="350"
    v-model="showModal"
  >
    <div class="position-relative">
      <div class="vm--top-right-slot" style="z-index: 1">
        <button type="button" class="btn p-0 pr-3 pt-3 border-0" @click="close">
          <i class="fas fa-times fa-lg"></i>
        </button>
      </div>
      <div class="card-body" :class="{ 'hide-alpha': hideAlpha }">
        <ColorPicker
          :color="currentColor"
          :onStartChange="(color) => onColorChange(color)"
          :onChange="(color) => onColorChange(color)"
          :onEndChange="(color) => onColorChange(color)"
        />
        <div
          class="col-12 p-0 d-flex justify-content-center mt-3 border-top pt-4"
        >
          <button type="button" class="btn btn-theme" @click="confirm">
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { ColorPicker } from "vue3-color-gradient-picker";
import { lockPageScroll, unlockPageScroll } from "@/utils/scrollLock";

export default {
  name: "ColorPickerModal",
  components: {
    ColorPicker,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "204, 204, 204, 1",
    },
    confirmText: {
      type: String,
      default: "Confirm Color",
    },
    modalName: {
      type: String,
      default: "color-picker-modal",
    },
    hideAlpha: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "confirm", "change"],
  data() {
    return {
      currentColor: {
        red: 204,
        green: 204,
        blue: 204,
        alpha: 1,
      },
      pageScrollLocked: false,
    };
  },
  computed: {
    showModal: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    modelValue(val) {
      if (val) {
        this.pageScrollLocked = lockPageScroll();
        this.currentColor = this.parseColor(this.color);
        return;
      }
      this.releasePageScroll();
    },
  },
  beforeUnmount() {
    this.releasePageScroll();
  },
  methods: {
    parseColor(colorString) {
      if (!colorString) {
        return { red: 204, green: 204, blue: 204, alpha: 1 };
      }
      const parts = colorString.split(",");
      return {
        red: parseInt(parts[0] || 204),
        green: parseInt(parts[1] || 204),
        blue: parseInt(parts[2] || 204),
        alpha: parseFloat(parts[3] || 1),
      };
    },
    colorValue() {
      return `${this.currentColor.red}, ${this.currentColor.green}, ${this.currentColor.blue}, ${this.currentColor.alpha}`;
    },
    onColorChange(color) {
      this.currentColor = { ...color };
      this.$emit("change", this.colorValue());
    },
    confirm() {
      this.$emit("confirm", this.colorValue());
      this.close();
    },
    close() {
      this.showModal = false;
    },
    releasePageScroll() {
      if (!this.pageScrollLocked) return;
      unlockPageScroll();
      this.pageScrollLocked = false;
    },
  },
};
</script>

<style lang="scss">
.ccc-modal-content.color-picker-modal-content {
  background-color: #ffffff;
}
</style>

<style scoped lang="scss">
// The package has no prop for alpha, and the last input wrapper is Alpha.
.hide-alpha {
  :deep(.alpha),
  :deep(.input-group > div:last-child) {
    display: none;
  }
}
</style>
